export default "/_next/static/images/65cce2b05f7381756d3ea0e97a02fc40.jpg";